// core
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// environment
import { environment } from '@open-portal-env';

// services
import {
  DocumentService,
  PartnerBrandService,
  LoggerService
} from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class DocumentsResolver implements Resolve<boolean> {
  apiEndpoint = environment.apiEndpoint;
  constructor(
    private documentService: DocumentService,
    public partnerBrandService: PartnerBrandService,
    private loggerService: LoggerService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> | Promise<any> | any {
    const partner = route.queryParams.partner || this.partnerBrandService.getAttribute('slug', 'partner') || 'open';
    this.partnerBrandService.setPartner(partner);

    return this.documentService.getPartnerDocuments(partner)
      .then((response: any) => this.processDocuments(response))
      .catch((error: any) => {
        this.loggerService.error('DocumentsResolver', 'getPartnerDocuments', error);
      });
  }

  // Process documents to filter out past documents
  processDocuments(documents: any): any {
    const partnerDocuments = documents || [];

    if (partnerDocuments?.categories) {
      partnerDocuments?.categories.forEach((category: any) => {
        category?.subcategories.forEach((subcategory: any) => {
          // Filter out documents that have ended
          subcategory.documents = subcategory?.documents.filter((document: any) => {
            // append the apiEndpoint to each documents URL.
            if (document.url) {
              document.url = this.apiEndpoint + document.url;
            }

            // If the document has no end date, it is considered valid
            if (!document.end_date) {
              return true;
            }
            const endDate = Date.parse(document.end_date);
            const now = Date.now();

            // If the document has ended, copy it to previous_documents
            if (endDate < now) {
              subcategory.previous_documents = subcategory.previous_documents || [];
              subcategory.previous_documents.push(document);
            }

            // Return true if the document is still valid
            return endDate >= now;
          });
        });
      });
    }
    
    return partnerDocuments;
  }
}
